/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link, NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Button, Drawer, IconButton } from '@material-ui/core';
import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";
import {ArrowDropDown, ArrowDropUp, Settings } from '@material-ui/icons';
import classNames from "classnames";
import Collapse from '@material-ui/core/Collapse';
import config from '../../lib/config';
const useStyles = makeStyles(styles);

export default function SidebarLinksAfterlogin(props) {
  const { classes1, handleDrawerOpen, open } = props

  const [open1, setOpen] = React.useState(true);
  const [open2, setOpen1] = React.useState(true);
  const [open3, setOpen2] = React.useState(true);
  const handleClick = () => {
    setOpen(!open1);
  };
  const handleClick1 = () => {
    setOpen1(!open2);
  };

  const handleClick2 = () => {
    setOpen2(!open3);
  };

  const classes = useStyles();
  return (
    <Drawer
      variant="permanent"
      className={classNames(classes1.drawer+ " dash_sidebar", {
        [classes1.drawerOpen]: open,
        [classes1.drawerClose + " minimumSidebar"]: !open
      })}
      classes={{
        paper: classNames({
          [classes1.drawerOpen]: open,
          [classes1.drawerClose]: !open
        })
      }}
      open={open}
    >
    <div className={classes1.toolbar} />
      <div className="sidebar_main">
        <List className="side_menu">
          <ListItem className="sideItem">
            <a href="https://valobitdx.io/" className="sideLink">
              <img src={require("../../assets/images/menu_icon_01.svg")} alt="Icon"/> Home
            </a>
          </ListItem>

          <ListItem className="sideItem">
            <a href="https://exchange.valobitdx.io/#/exchange" className="sideLink">
              <img src={require("../../assets/images/menu_icon_02.svg")} alt="Icon"/> Swap
            </a>
          </ListItem>

          <ListItem className="sideItem">
            <a href="https://exchange.valobitdx.io/#/pool" className="sideLink">
              <img src={require("../../assets/images/add_pool.png")} alt="Icon"/> Add Pool
            </a>
          </ListItem>

          {/* <ListItem className="sideItem" onClick={handleClick}>
            <a href="javascript:void(0)" className="sideLink" role="button" aria-expanded="false" aria-controls="earningDropDown">
              <img src={require("../../assets/images/menu_icon_02.svg")} alt="Icon"/>Trade
              {open1 ? <ArrowDropDown /> : <ArrowDropUp />}
            </a>
          </ListItem>
          <Collapse in={!open1} timeout="auto" unmountOnExit>
            <List className="sidebarDropdown">
              <ListItem>
                <a href="#" className="sideLink">Exchange</a>
              </ListItem>
              <ListItem>
                <a href="#" className="sideLink">Liquidity</a>
              </ListItem>
            </List>
          </Collapse> */}
        
          <ListItem className="sideItem">
            <a href="https://valobitdx.io/farms" className="sideLink">
              <img src={require("../../assets/images/menu_icon_03.svg")} alt="Icon"/> Farms
            </a>
          </ListItem>

          <ListItem className="sideItem">
            <a href="https://valobitdx.io/pools" className="sideLink">
              <img src={require("../../assets/images/menu_icon_04.svg")} alt="Icon"/>Pools
            </a>
          </ListItem>          

          <ListItem className="sideItem">
            <NavLink to="/nft" className="sideLink">
              <img src={require("../../assets/images/menu_icon_05.png")} alt="Icon"/>NFT
            </NavLink>
          </ListItem>
          <ListItem className="sideItem">
            <NavLink to="/stake" className="sideLink">
              <img src={require("../../assets/images/menu_icon_02.svg")} alt="Icon"/>Stake
            </NavLink>
          </ListItem>          
        </List>

        

        <div className="sidebar_footer_wrapper">
          <div className="siderbar_settings">
            <IconButton color="inherit" aria-label="Open drawer" onClick={handleDrawerOpen} className={classes.menuButton}>
              <Settings
                classes={{
                  root: open
                    ? classes.menuButtonIconOpen
                    : classes.menuButtonIconClosed
                }}
              />
            </IconButton>
          </div>
          <div className="sidebar_footer_top">
            <a href="#" className="token_stats">
              <img src={require("../../assets/images/logo_icon.png")} alt="Icon"/> <span>$9.751</span>
            </a>
            <ul className="sidebar_social_list">
              <li><a href="javascript:void(0)" target="_blank"><img src={require("../../assets/images/telegram.svg")} alt="Icon"/></a></li>
              <li><a href="javascript:void(0)" target="_blank"><img src={require("../../assets/images/twitter_icon.svg")} alt="Icon"/></a></li>
            </ul>
          </div>
          <div className="sidebar_footer_bottom">
            {/* <div className="language_selector">
              <img src={require("../../assets/images/globe_icon.png")} alt="Icon"/>
              <select className="form-control" id="exampleFormControlSelect2">
                <option>EN</option>
                <option>AR</option>
                <option>NL</option>
                <option>IT</option>
                <option>RO</option>
              </select>
            </div> */}

            {/* <label id="switch" className="switch">
              <input type="checkbox" id="theme_slider"/>
              <span className="theme_switcher round"></span>
            </label> */}
            <Button className="theme_switch_btn">
              {/* <img src={require("../../assets/images/sun_icon.svg")} alt="Icon"/> */}
              <svg viewBox="0 0 24 24" color="text" width="24px" xmlns="http://www.w3.org/2000/svg" class="sc-bdfBQB dKRNTX"><path d="M5.66 4.2L6.05 4.59C6.44 4.97 6.44 5.61 6.05 5.99L6.04 6C5.65 6.39 5.03 6.39 4.64 6L4.25 5.61C3.86 5.23 3.86 4.6 4.25 4.21L4.26 4.2C4.64 3.82 5.27 3.81 5.66 4.2Z"></path><path d="M1.99 10.95H3.01C3.56 10.95 4 11.39 4 11.95V11.96C4 12.51 3.56 12.95 3 12.94H1.99C1.44 12.94 1 12.5 1 11.95V11.94C1 11.39 1.44 10.95 1.99 10.95Z"></path><path d="M12 1H12.01C12.56 1 13 1.44 13 1.99V2.96C13 3.51 12.56 3.95 12 3.94H11.99C11.44 3.94 11 3.5 11 2.95V1.99C11 1.44 11.44 1 12 1Z"></path><path d="M18.34 4.2C18.73 3.82 19.36 3.82 19.75 4.21C20.14 4.6 20.14 5.22 19.75 5.61L19.36 6C18.98 6.39 18.35 6.39 17.96 6L17.95 5.99C17.56 5.61 17.56 4.98 17.95 4.59L18.34 4.2Z"></path><path d="M18.33 19.7L17.94 19.31C17.55 18.92 17.55 18.3 17.95 17.9C18.33 17.52 18.96 17.51 19.35 17.9L19.74 18.29C20.13 18.68 20.13 19.31 19.74 19.7C19.35 20.09 18.72 20.09 18.33 19.7Z"></path><path d="M20 11.95V11.94C20 11.39 20.44 10.95 20.99 10.95H22C22.55 10.95 22.99 11.39 22.99 11.94V11.95C22.99 12.5 22.55 12.94 22 12.94H20.99C20.44 12.94 20 12.5 20 11.95Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M6 11.95C6 8.64 8.69 5.95 12 5.95C15.31 5.95 18 8.64 18 11.95C18 15.26 15.31 17.95 12 17.95C8.69 17.95 6 15.26 6 11.95ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"></path><path d="M12 22.9H11.99C11.44 22.9 11 22.46 11 21.91V20.95C11 20.4 11.44 19.96 11.99 19.96H12C12.55 19.96 12.99 20.4 12.99 20.95V21.91C12.99 22.46 12.55 22.9 12 22.9Z"></path><path d="M5.66 19.69C5.27 20.08 4.64 20.08 4.25 19.69C3.86 19.3 3.86 18.68 4.24 18.28L4.63 17.89C5.02 17.5 5.65 17.5 6.04 17.89L6.05 17.9C6.43 18.28 6.44 18.91 6.05 19.3L5.66 19.69Z"></path></svg>
              <span>/</span>
              <svg viewBox="0 0 24 24" color="textDisabled" width="24px" xmlns="http://www.w3.org/2000/svg" class="sc-bdfBQB cqiDsM"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.1534 13.6089L4.15362 13.61C4.77322 16.8113 7.42207 19.3677 10.647 19.8853L10.6502 19.8858C13.0412 20.2736 15.2625 19.6103 16.9422 18.2833C11.3549 16.2878 7.9748 10.3524 9.26266 4.48816C5.69846 5.77194 3.35817 9.51245 4.1534 13.6089ZM10.0083 2.21054C4.76622 3.2533 1.09895 8.36947 2.19006 13.9901C2.97006 18.0201 6.28006 21.2101 10.3301 21.8601C13.8512 22.4311 17.0955 21.1608 19.2662 18.8587C19.2765 18.8478 19.2866 18.837 19.2968 18.8261C19.4385 18.6745 19.5757 18.5184 19.7079 18.3581C19.7105 18.355 19.713 18.3519 19.7156 18.3487C19.8853 18.1426 20.0469 17.9295 20.2001 17.7101C20.4101 17.4001 20.2401 16.9601 19.8701 16.9201C19.5114 16.8796 19.1602 16.8209 18.817 16.7452C18.7964 16.7406 18.7758 16.736 18.7552 16.7313C18.6676 16.7114 18.5804 16.6903 18.4938 16.6681C18.4919 16.6676 18.4901 16.6672 18.4882 16.6667C13.0234 15.2647 9.72516 9.48006 11.4542 4.03417C11.4549 4.03214 11.4555 4.03012 11.4562 4.0281C11.4875 3.92954 11.5205 3.83109 11.5552 3.73278C11.5565 3.72911 11.5578 3.72543 11.5591 3.72175C11.6768 3.38921 11.8136 3.05829 11.9701 2.73005C12.1301 2.39005 11.8501 2.01005 11.4701 2.03005C11.1954 2.04379 10.924 2.06848 10.6561 2.10368C10.6517 2.10427 10.6472 2.10486 10.6428 2.10545C10.4413 2.13221 10.2418 2.16492 10.0446 2.2034C10.0325 2.20576 10.0204 2.20814 10.0083 2.21054Z"></path></svg>
              {/* <img src={require("../../assets/images/moon_icon.svg")} alt="Icon"/> */}
            </Button>
          </div>
        </div>
      </div>    
    </Drawer>
  );
}
       